export type ModuleId = 'tasks' | 'completed' | 'groceries' | 'stock' | 'fyp' | 'states' | 'goals';

export const DEFAULT_MODULE_ORDER: ModuleId[] = ['fyp', 'tasks', 'completed', 'groceries', 'stock', 'states', 'goals'];

import type { TagIconId, TagType } from '@/types/tag';

export type TagIconMap = Partial<Record<TagType, TagIconId>>;

export interface Team {
  id: string;
  name: string;
  slug: string | null;
  slogan: string | null;
  imageUrl: string | null;
  createdAt: Date;
  createdByUserId: string | null;
  // Weekend window settings (when weekly "weekend" tasks can be completed)
  weekendStartDay: number; // 0=Sun, 1=Mon, ..., 5=Fri, 6=Sat
  weekendStartHour: number; // 0-23
  weekendEndDay: number; // 0=Sun, 1=Mon, etc.
  weekendEndHour: number; // 0-23 (0 = midnight)
  // Team-wide time of day settings
  morningHour: number; // Default 6 = 06:00
  eveningHour: number; // Default 18 = 18:00
  // Module visibility settings
  showFypModule?: boolean; // Default false/true
  showTasksModule: boolean; // Default true
  showCompletedModule: boolean; // Default true
  showGroceryModule: boolean; // Default true
  showStockModule: boolean; // Default true
  showGoalsModule?: boolean; // Default false
  moduleOrder: ModuleId[]; // Order of modules in navigation
  moduleLabels?: Partial<Record<ModuleId, string>>;
  tagIcons?: TagIconMap;
  language?: 'nl' | 'en';
  // Theme settings
  themePrimaryColor?: string;
  actionButtonBgColor?: string;
  actionButtonIconColor?: string;
  // Visibility
  isPublic?: boolean;
  // Invite code
  inviteCode?: string | null;
  inviteCodeEnabled?: boolean;
}
